// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"5939df68","507":"fb838be8","743":"383b4ff2"}[chunkId] + ".chunk.js";
};